<template>
  <div class="board" >
    <div >
      <Row :gutter="40" justify="center">
        <Col  span="7">
          <div class="cus-data">
            <div class="cus-data-title cus-data-title-bg1" >
              <p class="cus-data-title-p1">客户消费</p>
              <p class="cus-data-title-p2">消费数据</p>
              <!-- 悬浮AI按钮 -->
              <button class="ai-orb" @click="generateAIPortrait">
                <div class="holographic-ring"></div>
                <div class="neon-core">
                  <div class="energy-pulse"></div>
                  <div class="binary-particles"></div>
                </div>
                <span class="ai-text">AI</span>
                <svg class="ai-icon" viewBox="0 0 24 24">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-1-14h2v6h-2zm0 8h2v2h-2z"/>
                </svg>
              </button>
            </div>
            <div class="cus-data-content">
              <div class="cus-data-content-data" v-if="boardData.payoutLastThreeMonthsExpend != '-'">
                <div class="cus-data-content-left" >
                  <span class="data-span">
                    <Icon type="md-checkmark-circle" class="md-checkmark-circle"/>稳定性评级:{{ boardData.payoutStabilityRating }}<br>
                    <Icon type="md-checkmark-circle" class="md-checkmark-circle"/>近3个月均消费:{{ boardData.payoutLastThreeMonths }}元<br>
                     <Icon type="md-checkmark-circle" class="md-checkmark-circle"/>近3个月微信消费:{{ boardData.payoutLastThreeMonthsExpend }}元
                  </span>
                </div>
                <div class="cus-data-content-right" >
                  <span class="data-span">
                    <Icon type="md-checkmark-circle" class="md-checkmark-circle"/>月均支出:{{ homeStat.summary_metrics.payoutMonthAvg }}元<br>
                    <Icon type="md-checkmark-circle" class="md-checkmark-circle"/>近6个月均消费:{{ boardData.payoutLastSixMonths }}元<br>
                    <Icon type="md-checkmark-circle" class="md-checkmark-circle"/>近6个月微信消费:{{ boardData.payoutLastSixMonthsExpend }}元
                  </span>
                </div>
              </div>
              <div class="cus-data-content-data" v-else>
                <div class="cus-data-content-left" >
                  <span class="data-span">
                    <Icon type="md-checkmark-circle" class="md-checkmark-circle"/>稳定性评级:{{ boardData.payoutStabilityRating }}<br>
                    <Icon type="md-checkmark-circle" class="md-checkmark-circle"/>近3个月均消费:{{ boardData.payoutLastThreeMonths }}元
                   <br><br>
                  </span>
                </div>
                <div class="cus-data-content-right" >
                  <span class="data-span">
                    <Icon type="md-checkmark-circle" class="md-checkmark-circle"/>月均支出:{{ homeStat.summary_metrics.payoutMonthAvg }}元<br>
                    <Icon type="md-checkmark-circle" class="md-checkmark-circle"/>近6个月均消费:{{ boardData.payoutLastSixMonths }}元<br><br>
                  </span>
                </div>
              </div>
              <div class="cus-data-content-foot" >
                <div class="cus-data-content-describe">
                  <span class="clms-font">策略描述</span><br>
                  提供客户消费能力与消费数据，依据客户日常消费数据（消费数据不包含红包/还款等数据），预计客户收入能力，近3个月和6个月不包括转账，稳定性分为高中/低依次变差，近3个月按照近90天，近6个月按照近180天取数，下同
                </div>
              </div>
            </div>
          </div>
        </Col>
        <Col  span="7">
          <div class="cus-data">
            <div class="cus-data-title cus-data-title-bg2" >
              <p class="cus-data-title-p1">客户收入</p>
              <p class="cus-data-title-p2">收入数据</p>
              <!-- 悬浮AI按钮 -->
              <button class="ai-orb" @click="generateAIPortrait">
                <div class="holographic-ring"></div>
                <div class="neon-core">
                  <div class="energy-pulse"></div>
                  <div class="binary-particles"></div>
                </div>
                <span class="ai-text">AI</span>
                <svg class="ai-icon" viewBox="0 0 24 24">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-1-14h2v6h-2zm0 8h2v2h-2z"/>
                </svg>
              </button>
            </div>
            <div class="cus-data-content">
              <div class="cus-data-content-data">
                  <div class="cus-data-content-left" >
                    <span class="data-span">
                      <Icon type="md-checkmark-circle" class="md-checkmark-circle"/>稳定性评级：{{ boardData.incomeStabilityRating }}<br>
                      <Icon type="md-checkmark-circle" class="md-checkmark-circle"/>月均工资： {{ homeStat.incoming.wages.monthAvg }}元，{{ homeStat.incoming.wages.countData }}个月<br>
                      <Icon type="md-checkmark-circle" class="md-checkmark-circle"/>近3个月均收入：{{ boardData.incomeLastThreeMonths }}元
                    </span>
                  </div>
                  <div class="cus-data-content-right" >
                    <span class="data-span">
                      <Icon type="md-checkmark-circle" class="md-checkmark-circle"/>月均收单：{{ homeStat.incoming.posTrade.monthAvg }}元，{{ homeStat.incoming.posTrade.countData }}个月<br>
                      <Icon type="md-checkmark-circle" class="md-checkmark-circle"/>月均收入：{{ homeStat.summary_metrics.incomingMonthAvg}}元<br>
                      <Icon type="md-checkmark-circle" class="md-checkmark-circle"/>近6个月均收入：{{ boardData.incomeLastSixMonths }}元
                    </span>
                  </div>

              </div>
              <div class="cus-data-content-foot"  >
                <div >
                </div>
                <div class="cus-data-content-describe">
                  <span class="clms-font">策略描述</span><br>
                  个人客户主要是工资，小微商户主要是收单收入，近3个月和6个月不包括转账
                </div>
              </div>
            </div>
          </div>
        </Col>
        <Col  span="7">
          <div class="cus-data">
            <div class="cus-data-title cus-data-title-bg3" >
              <p class="cus-data-title-p1">客户资产</p>
              <p class="cus-data-title-p2">日均资产</p>
            </div>
            <div class="cus-data-content">
              <div class="cus-data-content-data">
                <div class="cus-data-content-left">
                  <span class="data-span">
                    <Icon type="md-checkmark-circle" class="md-checkmark-circle"/>稳定性评级:{{ boardData.assetDataStabilityRating }}<br>
                    <Icon type="md-checkmark-circle" class="md-checkmark-circle"/>近3个月日均:{{ boardData.assetDataThreeMonthDayAvg }}元
                    <br><br>
                  </span>
                </div>
                <div class="cus-data-content-right">
                  <span class="data-span">
                    <Icon type="md-checkmark-circle" class="md-checkmark-circle"/>日均资产:{{ homeStat.summary_metrics.assetDayAvg }}元<br>
                    <Icon type="md-checkmark-circle" class="md-checkmark-circle"/>近6个月日均:{{ boardData.assetDataSixMonthDayAvg }}元<br><br>
                  </span>
                </div>
              </div>
              <div class="cus-data-content-foot" >
                <div >
                </div>
                <div class="cus-data-content-describe">
                  <span class="clms-font">策略描述</span><br>
                  提供客户的银行卡余额日均情况，辅助证明客户的日常资产是否能否覆盖贷款额
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </div>
    <div class="content-bv" >
      <div class="bv-title">
        <span class="bv-title-cn">账单校验</span>
        <br>
        <span class="bv-title-en">BILL VERIFICATION</span>
      </div>
      <div class="bv-table">
        <Table border disabled-hover :columns="uploadColumns" :data="dataMap.uploadLog"></Table>
      </div>
      <div class="bv-foot bv-foot-font" >
        <span style="font-weight: bold;">策略描述</span><br>
        <span class="">微信和支付宝以及部分银行卡支持电子签名校验，如果电子签名校验失败则文件被改动过，<br>银行卡会进行余额连续性校验，即每笔交易金额是不是等于下一笔余额，极少银行交易排序不准确可能存在异常校验 ，详情有具体异常交易流水可以进行核验。<br>有些账户存在不同姓名使用的情况，此处会做标注。</span>
      </div>
    </div>
    <div class="content-settlement" v-if="dataMap.bank_view_data && dataMap.bank_view_data.length>0">
      <div class="bv-title">
        <span class="bv-title-cn">常用银行卡</span>
        <br>
        <span class="bv-title-en">COMMON BANK CARDS</span>
      </div>
      <div class="settlement-pic-table">
        <div class="bv-table">
          <Table border disabled-hover :columns="transferSummary" :data="dataMap.bank_view_data"></Table>
        </div>
      </div>
    </div>

    <div class="content-settlement" v-if="dataMap && dataMap.counterparty_summary && dataMap.counterparty_summary.length>0">
      <div class="bv-title">
        <span class="bv-title-cn">客户关联人</span>
        <br>
        <span class="bv-title-en">CUSTOMER RELATED PARTIES</span>
      </div>
      <div class="settlement-pic-table">
        <div class="bv-table">
          <Table border disabled-hover :columns="counterpartySummary" :data="dataMap.counterparty_summary"></Table>
        </div>
      </div>
      <div class="bv-foot bv-foot-font" >
        <span style="font-weight: bold;">策略描述</span><br>
        <span class="">根据客户转账的账户关系，判断客户是否存在关联人</span>
      </div>
    </div>

    <div class="content-settlement" v-if="boardData && boardData.settlementMapList && boardData.settlementMapList.length>0">
      <div class="bv-title">
        <span class="bv-title-cn">结息校验</span>
        <br>
        <span class="bv-title-en">INTEREST SETTLEMENT</span>
      </div>
      <div class="settlement-pic-table">
        <div class="bv-table">
          <Table border disabled-hover :columns="settlement" :data="boardData.settlementMapList"></Table>
        </div>
      </div>
      <div class="bv-foot bv-foot-font" >
        <span style="font-weight: bold;">策略描述</span><br>
        <span class="">根据客户的日均余额与活期利率计算与客户账单结息进行比对，判断客户是否存在造假行为。</span>
      </div>
    </div>
    <div class="content-bh">
      <div class="bv-title">
        <span class="bv-title-cn">司法与不良嗜好校验</span>
        <br>
        <span class="bv-title-en">JUDICIAL AND BAD HOBBY VERIFICATION</span>
      </div>
      <div class="bv-table">
        <Table border disabled-hover :columns="badHabit" :data="badHabitData"></Table>
      </div>
    </div>
    <div class="bv-foot bv-foot-font" >
        <span style="font-weight: bold;">策略描述</span><br>
        <span class="">不良嗜好识别数据，展示客户行为情况。</span><br>
        <span style="font-weight: bold;">娱乐校验：</span><span>消费中KTV会所等相关信息的所有支出且金额大于500,辅助判断客户是否存在黄赌情况。</span><br>
        <span style="font-weight: bold;">高频转账：</span><span>一天内向同一对象转账超过五次，辅助判断客户是否存在关联交易和赌博情况。</span><br>
        <span style="font-weight: bold;">夜间交易：</span><span>晚上24点到早上5点之间交易，少量可以忽略大量查看是否匹配行业，辅助判断客户是否存在赌博情况。</span><br>
        <span style="font-weight: bold;">典当交易：</span><span>客户典当交易情况，辅助判断客户是否存在赌博情况。</span><br>
        <span style="font-weight: bold;">司法校验：</span><span>判断微信或者支付宝以及银行账单中是否存在司法冻结或者司法解冻的情况，如果存在表明已经存在严重逾期。</span>
      </div>

    <zhixiReportLtd ref="zhixiReportLtdRef" @handle-search="handleSearch"></zhixiReportLtd>
    <aiReport ref="aiReport"></aiReport>
  </div>
</template>
<script>

import zhixiReportLtd from '@/view/canalyse/company/zhixi-report.vue'
import aiReport from '../ai-report.vue'
export default {
  components: { zhixiReportLtd, aiReport },
  props: {
    dataMap: Object,
    homeStat: Object,
    score: Object,
    boardData: Object
  },
  data () {
    return {
      gutter: 52,
      uploadColumns:
        [{
          key: 'billType',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-paper'
                },
                style: {
                  marginRight: '5pt'
                }
              }),
              h('strong', '账单类型')
            ])
          }
        }, {
          key: 'name',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-person'
                },
                style: {
                  marginRight: '5pt'
                }
              }),
              h('strong', '姓名')
            ])
          }
        }, {
          key: 'bankCardNo',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-card'
                },
                style: {
                  marginRight: '5pt'
                }
              }),
              h('strong', '账户')
            ])
          }
        }, {
          key: 'repeatAccount',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'md-repeat'
                },
                style: {
                  marginRight: '5pt'
                }
              }),
              h('strong', '账户存在重复使用')
            ])
          }
        }, {
          key: 'fileName',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-folder'
                },
                style: {
                  marginRight: '5pt'
                }
              }),
              h('strong', '文件')
            ])
          }
        }, {
          key: 'uploadTime',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-clock'
                },
                style: {
                  marginRight: '5pt'
                }
              }),
              h('strong', '上传时间')
            ])
          }
        }, {
          key: 'signNums',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-pricetag'
                },
                style: {
                  marginRight: '5pt'
                }
              }),
              h('strong', '电子签校验')
            ])
          }
        }, {
          key: 'continuity',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-checkmark-circle'
                },
                style: {
                  marginRight: '5pt'
                }
              }),
              h('strong', '余额连续性校验')
            ])
          }
        }, {
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-settings'
                },
                style: {
                  marginRight: '5pt'
                }
              }),
              h('strong', '操作')
            ])
          },
          render: (h, params) => {
            return h('Button', {
              props: {
                type: 'primary',
                size: 'small',
                icon: 'md-return-right'
              },
              style: {
                display: params.row.subId ? 'inline-block' : 'none'
              },
              on: {
                click: () => {
                  this.jumpPage(params.row)
                }
              }
            }, '跳转公司流水分析报告')
          }
        }
        ],
      transferSummary:
        [
          {
            key: 'cardNo',
            className: 'table-header-cell',
            renderHeader: (h, params) => {
              return h('div', [
                h('Icon', {
                  props: {
                    type: 'md-shuffle'
                  },
                  style: {
                    marginRight: '5pt'
                  }
                }),
                h('strong', '渠道名称')
              ])
            }
          }, {
            key: 'businessType',
            className: 'table-header-cell',
            renderHeader: (h, params) => {
              return h('div', [
                h('Icon', {
                  props: {
                    type: 'ios-card'
                  },
                  style: {
                    marginRight: '5pt'
                  }
                }),
                h('strong', '银行/卡号')
              ])
            }
          }, {
            key: 'yearAvg',
            className: 'table-header-cell',
            renderHeader: (h, params) => {
              return h('div', [
                h('Icon', {
                  props: {
                    type: 'logo-yen'
                  },
                  style: {
                    marginRight: '5pt'
                  }
                }),
                h('strong', '收入')
              ])
            }
          },
          {
            key: 'monthAvg',
            className: 'table-header-cell',
            renderHeader: (h, params) => {
              return h('div', [
                h('Icon', {
                  props: {
                    type: 'logo-yen'
                  },
                  style: {
                    marginRight: '5pt'
                  }
                }),
                h('strong', '支出')
              ])
            }
          },
          {
            key: 'countData',
            className: 'table-header-cell',
            renderHeader: (h, params) => {
              return h('div', [
                h('Icon', {
                  props: {
                    type: 'ios-podium'
                  },
                  style: {
                    marginRight: '5pt'
                  }
                }),
                h('strong', '交易笔数')
              ])
            }
          }, {
            key: 'money',
            className: 'table-header-cell',
            renderHeader: (h, params) => {
              return h('div', [
                h('Icon', {
                  props: {
                    type: 'md-basket'
                  },
                  style: {
                    marginRight: '5pt'
                  }
                }),
                h('strong', '交易金额')
              ])
            }
          }, {
            key: 'dayAvg',
            className: 'table-header-cell',
            renderHeader: (h, params) => {
              return h('div', [
                h('Icon', {
                  props: {
                    type: 'md-cloud-upload'
                  },
                  style: {
                    marginRight: '5pt'
                  }
                }),
                h('strong', '是否已上传')
              ])
            },
            render: (h, params) => {
              return h('div', [
                h('div', params.row.dayAvg === 'Y' ? '是' : '否')
              ])
            }
          },
          {
            key: 'billAvg',
            className: 'table-header-cell',
            renderHeader: (h, params) => {
              return h('div', [
                h('Icon', {
                  props: {
                    type: 'ios-checkmark-circle'
                  },
                  style: {
                    marginRight: '5pt'
                  }
                }),
                h('strong', '交叉检验')
              ])
            },
            render: (h, params) => {
              return h('div', [
                h('div', params.row.billAvg === 'Y' ? '通过' : (params.row.billAvg === 'N' ? '未通过' : ''))
              ])
            }
          }, {
            key: 'billType',
            className: 'table-header-cell',
            renderHeader: (h, params) => {
              return h('div', [
                h('Icon', {
                  props: {
                    type: 'md-basket'
                  },
                  style: {
                    marginRight: '5pt'
                  }
                }),
                h('strong', '本转本占比')
              ])
            }
          }],
      settlement:
        [{
          key: 'billAvg',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-card'
                },
                style: {
                  marginRight: '5pt'
                }
              }),
              h('strong', '银行')
            ])
          }
        }, {
          key: 'statTime',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-clock'
                },
                style: {
                  marginRight: '5pt'
                }
              }),
              h('strong', '结息日期')
            ])
          }
        }, {
          key: 'money',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'logo-yen'
                },
                style: {
                  marginRight: '5pt'
                }
              }),
              h('strong', '结息金额')
            ])
          }
        }, {
          key: 'yearAvg',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-pulse'
                },
                style: {
                  marginRight: '5pt'
                }
              }),
              h('strong', '利率')
            ])
          }
        }, {
          key: 'billType',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-bookmark'
                },
                style: {
                  marginRight: '5pt'
                }
              }),
              h('strong', '是否有效结息')
            ])
          }
        }, {
          key: 'monthAvg',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-analytics'
                },
                style: {
                  marginRight: '5pt'
                }
              }),
              h('strong', '计算结息')
            ])
          }
        }, {
          key: 'dayAvg',
          className: 'table-header-cell',
          render: function (h, params) {
            const isHighlight = params.row.countData === 'Y'
            const style = isHighlight ? { color: 'red', fontWeight: 'bold' } : {}
            return h('div', [
              h('span', { style }, params.row.dayAvg ? params.row.dayAvg + '%' : '')
            ])
          },
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-sad'
                },
                style: {
                  marginRight: '5pt'
                }
              }),
              h('strong', '偏差率')
            ])
          }
        }, {
          key: 'countData',
          className: 'table-header-cell',
          render: (h, params) => {
            return h('div', [
              h('suibian', params.row.countData === '' ? '通过' : '大于10%')
            ])
          },
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-checkmark-circle'
                },
                style: {
                  marginRight: '5pt'
                }
              }),
              h('strong', '结息检验')
            ])
          }
        }
        ],
      counterpartySummary:
        [{
          key: 'businessType',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-card'
                },
                style: {
                  marginRight: '5pt'
                }
              }),
              h('strong', '关联人姓名')
            ])
          }
        }, {
          key: 'cardNo',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-clock'
                },
                style: {
                  marginRight: '5pt'
                }
              }),
              h('strong', '关联人身份证号')
            ])
          }
        }, {
          key: 'money',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'logo-yen'
                },
                style: {
                  marginRight: '5pt'
                }
              }),
              h('strong', '涉及金额')
            ])
          }
        }, {
          key: 'countData',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-checkmark-circle'
                },
                style: {
                  marginRight: '5pt'
                }
              }),
              h('strong', '交易次数')
            ])
          }
        }
        ],
      badHabit:
        [{
          key: 'billType',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'logo-playstation'
                },
                style: {
                  marginRight: '5pt'
                }
              }),
              h('strong', '娱乐校验')
            ])
          }
        }, {
          key: 'name',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'logo-buffer'
                },
                style: {
                  marginRight: '5pt'
                }
              }),
              h('strong', '高频转账')
            ])
          }
        }, {
          key: 'bankCardNo',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'md-moon'
                },
                style: {
                  marginRight: '5pt'
                }
              }),
              h('strong', '夜间交易')
            ])
          }
        }, {
          key: 'pwan',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'md-cash'
                },
                style: {
                  marginRight: '5pt'
                }
              }),
              h('strong', '典当交易')
            ])
          }
        }, {
          key: 'judicial',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'md-cash'
                },
                style: {
                  marginRight: '5pt'
                }
              }),
              h('strong', '司法校验')
            ])
          }
        }
        ],
      badHabitData: [ {
        billType: '涉及金额:￥' + this.homeStat.blackTrade.leisureEntertainment.money + '元',
        name: '涉及金额:￥' + this.homeStat.blackTrade.highFrequencyTransfer.money + '元',
        bankCardNo: '涉及金额:￥' + this.homeStat.blackTrade.nightTradeList.money + '元',
        pwan: '涉及金额:￥' + this.homeStat.blackTrade.pawnTradingList.money + ' 元',
        judicial: '涉及金额:￥' + this.homeStat.blackTrade.judicialFreeze.money + ' 元'
      }, {
        billType: this.getBlackTradeResult(this.homeStat.blackTrade.leisureEntertainment.money),
        name: this.getBlackTradeResult(this.homeStat.blackTrade.highFrequencyTransfer.money),
        bankCardNo: this.getBlackTradeResult(this.homeStat.blackTrade.nightTradeList.money),
        pwan: this.getBlackTradeResult(this.homeStat.blackTrade.pawnTradingList.money),
        judicial: this.getBlackTradeResult(this.homeStat.blackTrade.judicialFreeze.money)
      }
      ]
    }
  },
  mounted: function () {
  },
  methods: {
    jumpPage (param) {
      console.info(param)
      param.id = param.subId
      this.$refs.zhixiReportLtdRef.openModel('detail', param)
    },
    getBlackTradeResult (money) {
      if (money === '0') {
        return '通过'
      } else {
        return '存在,请重点关注'
      }
    },

    getBankViewData (dayAvg) {
      if (dayAvg === 'N') {
        return '否'
      } else {
        return '是'
      }
    },
    closeModel () {
      this.isShow = false
    },
    generateAIPortrait () {
      this.$refs.aiReport.openModelOne('detail', this.dataMap.uploadLog[0].customId)
    }
  }
}
</script>
<style>

.ivu-table td {
  background-color: #F5F5F5;
}
.ivu-table th.table-header-cell {
  background: #1242CD;
  font-family: Microsoft YaHei;
  font-weight: bold;
  font-size: 12pt;
  color: #FFFFFF;
  text-align: center;
  border: #1242CD;
}
.board {
  width: 100%;
}
.cus-data {
  width: 90%;
  height: 100%;
  background: #FFFFFF;
  box-shadow: 0 0 30pt 0 rgba(0,0,0,0.06);
  padding-top: 5%;
  border-radius: 30px;
}
.cus-data-title {
  width: 90%;
  margin-left: 5%;
  aspect-ratio: 800 / 278;
  font-family: Microsoft YaHei;
  color: #FFFFFF;
  font-size: 20pt;
  padding-top: 5%;
}
.cus-data-title-p1 {
  margin-left: 5%;
  font-size: 20pt;
  font-weight: bold;
}
.cus-data-title-p2 {
  font-size: 14pt;
  margin-left: 5%;
  margin-top: 4%;
}
.cus-data-title-bg1 {
  background-image: url(../../../../assets/images/content-v4/board/cust-data-title1.png);
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
}
.cus-data-title-bg2 {
  background-image: url(../../../../assets/images/content-v4/board/cust-data-title2.png);
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
}
.cus-data-title-bg3 {
  background-image: url(../../../../assets/images/content-v4/board/cust-data-title3.png);
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
}
.cus-data-content {
  //height: 400pt;
  width: 100%;
}
.cus-data-content-data {
  margin-top: 10pt;
}
.data-span {
  font-family: Microsoft YaHei;
  font-weight: bold;
  font-size: 10pt;
  color: #333333;
  line-height: 30pt;
}
.clms-font {
  font-family: Microsoft YaHei;
  font-size: 10pt;
  color: #666666;
}
.cus-data-content-describe {
  //height: 96pt;
  //height: 100%;
  margin: 0 20pt 20pt 20pt;
  font-family: Microsoft YaHei;
  font-size: 8pt;
  color: #999999;
  line-height: 17pt;
}
.cus-data-content-foot {
  margin-top: 5%;
}
.content-bv {
  margin-top: 20pt;
}
.bv-title-cn {
  font-family: Microsoft YaHei;
  font-weight: bold;
  font-size: 14pt;
  color: #333333;
}
.bv-title-en {
  font-family: Microsoft YaHei;
  font-weight: 400;
  font-size: 8pt;
  color: #999999;
}
.bv-table {
  margin-top: 10pt;
}
.bv-foot {
  margin-top: 10pt;
}
.bv-foot-font {
  font-family: Microsoft YaHei;
  font-size: 8pt;
  color: #333333;
}
.content-settlement {
  margin-top: 20pt;
}
.settlement-pic-table {
  //margin-top: 35pt;
}

.content-bh {
  margin-top: 20pt;
}
.md-checkmark-circle {
  color: #1342CE;
}
.cus-data-content-left {
  display: inline-block;
  vertical-align: top;
  width: 45%;
  margin-left: 5%;
  border-right:1px dashed #d3caca;
}
.cus-data-content-right {
  display: inline-block;
  vertical-align: top;
  width: 45%;
  margin-right: 5%;
}
/* 父容器设置定位上下文 */
.cus-data-title {
  position: relative; /* 关键定位设置 */
  min-height: 80px; /* 确保有足够空间 */
  padding-right: 100px; /* 为按钮留出空间 */
}
.ai-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-family: 'Orbitron', sans-serif; /* 使用科技感字体 */
  font-size: 1.4em;
  font-weight: 900;
  color: #00fffb;
  text-shadow:
    0 0 10px #00b4d8,
    0 0 20px #3a0ca3,
    0 0 30px #480ca8;
  z-index: 15;
  animation:
    textGlow 2s ease-in-out infinite,
    textFloat 3s ease-in-out infinite;
}
/* 文字辉光动画 */
@keyframes textGlow {
  0%, 100% {
    opacity: 0.9;
    filter: hue-rotate(0deg);
  }
  50% {
    opacity: 0.6;
    filter: hue-rotate(45deg);
  }
}
/* 文字浮动动画 */
@keyframes textFloat {
  0%, 100% { transform: translate(-50%, -50%) scale(1); }
  50% { transform: translate(-50%, -55%) scale(1.05); }
}

/* 未来科技风格悬浮按钮 */
.ai-orb {
  position: absolute;
  right: 25px;
  top: 50%;
  transform: translateY(-50%);
  width: 60px;
  height: 60px;
  border: none;
  background: rgba(0, 180, 216, 0.1);
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  overflow: visible;
  z-index: 10;
}

/* 全息光环效果 */
.holographic-ring {
  position: absolute;
  width: 130%;
  height: 130%;
  top: -15%;
  left: -15%;
  border: 2px solid rgba(0, 180, 216, 0.3);
  border-radius: 50%;
  animation: orbit 6s linear infinite;
  box-shadow: 0 0 15px rgba(58, 12, 163, 0.2);
}

@keyframes orbit {
  0% { transform: rotate(0deg) scale(1); }
  50% { transform: rotate(180deg) scale(1.1); }
  100% { transform: rotate(360deg) scale(1); }
}

/* 增强核心能量效果 */
.neon-core {
  background: radial-gradient(
    circle at 50% 50%,
    rgba(0, 180, 216, 0.9) 0%,
    rgba(58, 12, 163, 0.8) 70%
  );
  filter:
    blur(10px)
    contrast(1.5);
}

.energy-pulse {
  position: absolute;
  width: 100%;
  height: 100%;
  background: radial-gradient(
    circle,
    rgba(255,255,255,0.8) 10%,
    transparent 30%
  );
  animation: pulse 2s ease-in-out infinite;
}

@keyframes pulse {
  0% { opacity: 0.8; transform: scale(1); }
  50% { opacity: 0.4; transform: scale(1.3); }
  100% { opacity: 0.8; transform: scale(1); }
}

/* 二进制粒子效果 */
.binary-particles {
  position: absolute;
  width: 200%;
  height: 200%;
  left: -50%;
  top: -50%;
  background:
    repeating-linear-gradient(
      45deg,
      transparent,
      transparent 15px,
      rgba(0,228,255,0.1) 15px,
      rgba(0,228,255,0.1) 30px
    );
  animation: flow 20s linear infinite;
  opacity: 0;
  transition: opacity 0.3s;
}

/* 优化粒子流动效果 */
@keyframes flow {
  from { transform: rotate(0deg) scale(1); }
  to { transform: rotate(360deg) scale(1.2); }
}

/* 悬停交互效果 */
.ai-orb:hover {
  transform: translateY(-50%) scale(1.15);
  filter: brightness(1.2);

  .holographic-ring {
    border-color: rgba(0,228,255,0.6);
    box-shadow: 0 0 30px rgba(0,228,255,0.3);
  }

  .binary-particles {
    opacity: 0.6;
  }
}

/* 点击效果 */
.ai-orb:active {
  transform: translateY(-50%) scale(0.9);
  animation: energy-surge 0.3s;
}

@keyframes energy-surge {
  50% { box-shadow: 0 0 40px rgba(0,228,255,0.5); }
}

/* AI图标增强 */
.ai-icon {
  width: 24px;
  height: 24px;
  filter: drop-shadow(0 0 6px rgba(0,228,255,0.8));
  opacity: 0.7;
  transition: all 0.3s;
}

/* 悬停时文字与图标互动 */
.ai-orb:hover {
  .ai-text {
    text-shadow:
      0 0 20px #00b4d8,
      0 0 40px #3a0ca3,
      0 0 60px #480ca8;
    transform: translate(-50%, -50%) scale(1.2);
  }

  .ai-icon {
    opacity: 0;
    transform: translateY(10px);
  }
}

</style>
